/**
 * Format ngày/giờ hiển thị UI — chốt chuẩn dd/mm/yyyy toàn bộ app.
 *
 * KHÔNG dùng `Date.prototype.toLocaleDateString("vi-VN")` — locale "vi-VN"
 * không zero-pad ngày/tháng đơn (vd "13/7/2026" thay vì "13/07/2026") và
 * `toLocaleString` xếp giờ trước ngày ("10:30:00 13/7/2026"), không nhất quán
 * giữa các nơi trong UI.
 */

const DATE_ONLY_RE = /^\d{4}-\d{2}-\d{2}$/;

function toValidDate(value: string | number | Date | null | undefined): Date | null {
  if (value === null || value === undefined || value === "") return null;
  const d = value instanceof Date ? value : new Date(value);
  return Number.isNaN(d.getTime()) ? null : d;
}

const pad2 = (n: number) => String(n).padStart(2, "0");

/**
 * "13/07/2026" — trả về "—" nếu value null/rỗng/invalid.
 *
 * String dạng "YYYY-MM-DD" (DateField thuần, vd `effective_from`/`starts_at`)
 * được parse trực tiếp từng phần — KHÔNG qua `new Date()` + local timezone,
 * vì browser ở timezone âm (UTC-x) sẽ lùi 1 ngày khi convert "YYYY-MM-DD"
 * (hiểu là UTC midnight) sang giờ địa phương.
 */
export function formatDate(value: string | number | Date | null | undefined): string {
  if (typeof value === "string" && DATE_ONLY_RE.test(value)) {
    const [y, m, d] = value.split("-");
    return `${d}/${m}/${y}`;
  }
  const d = toValidDate(value);
  if (!d) return "—";
  return `${pad2(d.getDate())}/${pad2(d.getMonth() + 1)}/${d.getFullYear()}`;
}

/** "13/07/2026 10:30:00" — trả về "—" nếu value null/rỗng/invalid. */
export function formatDateTime(value: string | number | Date | null | undefined): string {
  const d = toValidDate(value);
  if (!d) return "—";
  return `${formatDate(d)} ${pad2(d.getHours())}:${pad2(d.getMinutes())}:${pad2(d.getSeconds())}`;
}
